<template>
    <v-dialog v-model="dialog" max-width="350" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ editing ? $t('exercises.edit_rest') : $t('exercises.add_rest') }}
            </v-card-title>
            <v-card-text class="mt-3" style="height: 200px">
                <v-row>
                    <v-col cols="12" class="text-center">
                        <div class="caption accent--text">
                            {{ $t('exercises.add_rest_subtitle') }}
                        </div>
                        <kimsa-time-picker ref="picker" :value="time" @change="onChange"/>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-btn :disabled="disabled" @click="setRest" color="primary"
                       class="black--text normal-btn no-radius" depressed x-large block>
                    {{ $t('common.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {mapState, mapMutations} from 'vuex'
import KimsaTimePicker from "@/components/common/KimsaTimePicker";

export default {
    name: 'RestDialog',
    props: {
        asMenu: {
            type: Boolean,
            default: false,
        },
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: null,
        }
    },
    components: {
        KimsaTimePicker,
    },
    data() {
        return {
            editing: false,
            time: '00:00:00',
            dialog: false,
        }
    },
    computed: {
        ...mapState(['dialogActive', 'secondDialogActive']),
        disabled(vm = this) {
            return !vm.time || vm.time === '00:00:00'
        }
    },
    mounted() {
        const vm = this
        vm.setDefault()
    },
    methods: {
        ...mapMutations(['setDialogActive', 'setSecondDialogActive']),
        onChange(time) {
            const vm = this
            vm.time = time
        },
        show(edit) {
            const vm = this
            if (!edit) vm.time = '00:00:00'
            vm.dialog = true
            vm.isSecondDialog ? vm.setSecondDialogActive(true) : vm.setDialogActive(true)
            if (vm.$refs.picker) vm.$refs.picker.setDefault()
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.editing = false
            vm.isSecondDialog ? vm.setSecondDialogActive(false) : vm.setDialogActive(false)
        },
        showEdit(time) {
            const vm = this
            vm.editing = true
            vm.time = time
            vm.show(true)
        },
        setRest() {
            const vm = this
            vm.$emit('save', vm.time)
            vm.hide()
        },
        setDefault() {
            const vm = this
            if (!vm.value) return
            vm.time = vm.value
        }
    },
    watch: {
        value() {
            this.setDefault()
        },
        dialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        secondDialogActive(val) {
            if (!val && this.dialog) this.hide()
        }
    }
}

</script>

<style scoped>

.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}

</style>